if (!customElements.get('localization-form')) {
  customElements.define('localization-form', class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.cookieName = "shippingShown";
      this.cookieNameLocal = "localePopup";
      // Cache elements
      this.elements = {
        locale: this.querySelector('input[name="locale_code"]'),
        country: this.querySelector('input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      
      // Add event listeners
      this.elements.button.addEventListener('click', this.openSelector.bind(this));

      // Check if the cookie is set
      if (this.getCookie(this.cookieName) === "shippingShown" || this.getCookie(this.cookieNameLocal) === "shown") {
        document.querySelector('#CurrencyDrawer-Close').style.display = 'block';
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      } else {
        document.querySelector('#CurrencyDrawer-Close').style.display = 'none';
      }
      
      // Add keyup listener for closing
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      // Add click listeners to links
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));

      // Update the count of available countries
      this.updateCountryCount();
    }

    updateCountryCount() {
      const countriesCount = document.querySelectorAll('#HeaderCountryMobileForm > a').length;
      const drawer = this.closest('currency-drawer');

      if (drawer) {
        const countEl = drawer.querySelector('.drawer__header .items-count');
        if (countEl) {
          countEl.textContent = countriesCount;
        }
      }
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.setCookie(this.cookieName, "shippingShown", 60);
      const isRedirect = event.currentTarget.dataset.redirect === 'true';

      if (isRedirect) {
        window.location.href = event.currentTarget.href;
        return;
      }

      const form = this.querySelector('form');
      this.elements.country ? this.elements.country.value = event.currentTarget.dataset.country : null;
      this.elements.locale ? this.elements.locale.value = event.currentTarget.dataset.language : null;
      
      let selectedCountry = event.currentTarget.dataset.country;
     
      //  Infer language from country - empty when lang selector is used
      let selectedlanguage = selectedCountry ? selectedCountry.toUpperCase() : '';

      // Handle Denmark
      if ( selectedlanguage == 'DK' ) {
        selectedlanguage == "DA";
      }

      // Also change language to match selected market/country
      let langInput = document.createElement('input');
      langInput.type = 'hidden';
      langInput.name = 'language_code';
      langInput.value = selectedlanguage;

      // Append it to the form
      form.appendChild(langInput);

      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const isChild = this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
      if (!event.relatedTarget || !isChild) {
        this.hidePanel();
      }
    }

    getCookie(cookieName) {
      const cookieString = document.cookie;
      const cookies = cookieString.split("; ");
      const cookie = cookies.find(row => row.startsWith(`${cookieName}=`));
      const result = cookie ? decodeURIComponent(cookie.split('=')[1]) : null;
      return result;
    }

    setCookie(cName, cValue, expDays) {
      const date = new Date();
      date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000);
      const expires = "expires=" + date.toUTCString();
      document.cookie = `${cName}=${cValue}; ${expires}; path=/`;
    }
  });
}
